import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { FaSun, FaMoon } from "react-icons/fa";
import { plateformSettingServices } from "../../../APIServices/PasswordManagement/plateformSettingServices";
import Swal from "sweetalert2";

const AppearanceSettings = ({
  getSinglePlateformSettings,
  plateformSettings,
  auth
}) => {
  const [themeSettings, setThemeSettings] = useState("light");
  const [loader, setLoader] = useState(false);

  const updateTheme = async (theme) => {
    if (loader || theme === themeSettings) return;

    Swal.fire({
      title: "Apply theme?",
      text: `Switch to ${theme} mode?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, apply",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        setThemeSettings(theme); 
        const data =
          await plateformSettingServices.addUpdatePlateformSettings(auth, {
            themeSettings: theme,
          });

        if (data?.statusCode === 200) {
          localStorage.setItem("themeSettings", theme);
          getSinglePlateformSettings();
        }
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (plateformSettings) {
      setThemeSettings(
        plateformSettings?.settings?.themeSettings || "light"
      );
    }
  }, [plateformSettings]);

  const ThemeBox = ({ type, icon, label }) => {
    const active = themeSettings === type;

    return (
      <Card
        onClick={() => updateTheme(type)}
        className={`border rounded-1 text-center p-3 ${ active ? "border-primary" : "border"}`}
        style={{
          width: "48%",
          cursor: loader ? "not-allowed" : "pointer",
          opacity: loader ? 0.6 : 1,
          transition: "all 0.2s ease",
        }}
      >
        <div className="mb-2">{icon}</div>
        <div className="fw-bold" style={{ fontSize: 13 }}>
          {label}
        </div>
      </Card>
    );
  };

  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3">
        <h5 className="fw-bold mb-1">Appearance Settings</h5>
      </div>

      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <div className="fw-bold mb-3" style={{ fontSize: 13 }}>
                Theme Settings{" "}
                <abbr className="text-danger" title="Require">
                  *
                </abbr>
              </div>

              <div className="d-flex justify-content-between">
                <ThemeBox
                  type="light"
                  label="Light"
                  icon={<FaSun size={20} />}
                />
                <ThemeBox
                  type="dark"
                  label="Dark"
                  icon={<FaMoon size={20} />}
                />
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AppearanceSettings;
